import { utils } from '@atlaskit/util-service-support';
import { DEFAULT_GRAPHQL_ENDPOINT } from '../constants';
import { RelatedEntitiesQuery } from './RelatedEntitiesQuery';
export var fetchRelatedEntities = function fetchRelatedEntities(variables) {
  var options = {
    requestInit: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: RelatedEntitiesQuery,
        variables: variables
      })
    },
    queryParams: {
      q: 'RelatedEntities'
    }
  };
  return utils.requestService({
    url: DEFAULT_GRAPHQL_ENDPOINT
  }, options);
};